import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useOnboard } from "../../../../hooks/OnboardContext";
import { i18n } from "../../../../localization/i18n";
import { useAuth } from "../../../../hooks/AuthContext";
import { showToast } from "../../../../components/CustomToast";
import { customerSituations } from "../../../../utils/constants";
import { 
  Container, 
  HeaderSection, 
  Title,
  TopSection,
  Badge, 
  AssistantGreeting,
  Avatar,
  GreetingText,
  QuickActionsGrid,
  ActionCard,
  IconWrapper,
  TextWrapper,
  CardTitle,
  CardDescription,
  ChatSection,
  ChatBoxContainer,
  ChatTextArea,
  ChatFooter,
  SuggestionsContainer,
  SuggestionChip,
  SendButton
} from "./styles";
import { 
  RiStore2Line, 
  RiFileList3Line, 
  RiMegaphoneLine,
  RiSendPlane2Fill
} from "react-icons/ri";
import { BiBookOpen } from "react-icons/bi";
import { FaStar } from "react-icons/fa";
import BotAvatar from "../../../../assets/symbol-purple.svg";

export default function Dashboard() {
  const { licensee } = useOnboard();
  const navigate = useNavigate();
  const { setNavigationAction, user } = useAuth();
  
  useEffect(() => {
    handleOnboardingStatus();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleOnboardingStatus() {
    if (
      licensee?.completed_onboard &&
      licensee?.situation === customerSituations.onboarding
    ) {
      navigate("/fixiter/onboard");
    }
  }

  useEffect(() => {
    setNavigationAction({
      hasButton: false,
      description: i18n.t("sidebar.home") || "Início",
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleChatUnavailable() {
    showToast({ 
      type: "info", 
      message: "A Inteligência Artificial da Fix it estará disponível em breve!" 
    });
  }

  return (
    <Container>
      <TopSection>
        <HeaderSection>
          <Title>Boas-vindas, {user?.person?.name?.split(' ')[0] || "Fixiter"}!</Title>
          {/* Placeholder for future backend prop: licensee.badge */}
          <Badge>
            <FaStar /> Fixiter Silver
          </Badge>
        </HeaderSection>

        <AssistantGreeting>
          <Avatar src={BotAvatar} alt="Assistente Fix it" />
          <GreetingText>Como posso te ajudar a crescer hoje?</GreetingText>
        </AssistantGreeting>

        <QuickActionsGrid>
          <ActionCard onClick={() => window.open('http://loja.usefixit.com.br/', '_blank')}>
            <IconWrapper>
              <RiStore2Line />
            </IconWrapper>
            <TextWrapper>
              <CardTitle>Loja Fix it 3D</CardTitle>
              <CardDescription>Compre Órteses Fix it 3D para atender seus pacientes.</CardDescription>
            </TextWrapper>
          </ActionCard>

          <ActionCard onClick={() => navigate("/fixiter/courses")}>
            <IconWrapper>
              <BiBookOpen />
            </IconWrapper>
            <TextWrapper>
              <CardTitle>Treinamentos</CardTitle>
              <CardDescription>Continue seus estudos.</CardDescription>
            </TextWrapper>
          </ActionCard>

          <ActionCard onClick={() => window.open('https://usefixit.com.br/', '_blank')}>
            <IconWrapper>
              <RiMegaphoneLine />
            </IconWrapper>
            <TextWrapper>
              <CardTitle>Materiais de Marketing</CardTitle>
              <CardDescription>Acesse conteúdos para divulgar.</CardDescription>
            </TextWrapper>
          </ActionCard>

          <ActionCard onClick={() => navigate("/fixiter/certificate")}>
            <IconWrapper>
              <RiFileList3Line />
            </IconWrapper>
            <TextWrapper>
              <CardTitle>Meu Certificado</CardTitle>
              <CardDescription>Baixe seu certificado de conclusão.</CardDescription>
            </TextWrapper>
          </ActionCard>
        </QuickActionsGrid>
      </TopSection>

      <ChatSection>
        <ChatBoxContainer onClick={handleChatUnavailable}>
          <ChatTextArea 
            placeholder="Pergunte ou descreva o que você precisa..." 
            disabled 
          />
          
          <ChatFooter>
            <SuggestionsContainer>
              <SuggestionChip>
                💡 Me ajude a negociar com pacientes
              </SuggestionChip>
              <SuggestionChip>
                🚀 Como divulgar nas redes sociais?
              </SuggestionChip>
              <SuggestionChip>
                📁 Onde encontro o portfólio?
              </SuggestionChip>
            </SuggestionsContainer>
            
            <SendButton disabled>
              <RiSendPlane2Fill />
            </SendButton>
          </ChatFooter>
        </ChatBoxContainer>
      </ChatSection>
    </Container>
  );
}
